import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  validateWrongProductCondition,
  wrongProductFromModel,
  type WrongProductState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const WRONG_PRODUCT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<WrongProductState>>,
): ConditionType<WrongProductState, Condition.WrongProduct> => ({
  name: CONDITION_NAMES[Condition.WRONG_PRODUCT],
  description(state) {
    return t("Return is for wrong product");
  },
  Details(props: ConditionTypeDetailsProps<WrongProductState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return wrongProductFromModel(model);
  },
  toModel(state) {
    return { type: Condition.WRONG_PRODUCT };
  },
  valid(state) {
    return validateWrongProductCondition(state).valid;
  },
});
